import { useMemo } from 'react';

import * as Sentry from '@sentry/react';

import { useUserStore } from '../store/userStore';

function useUserInfo() {
    const user = useUserStore.use.user();
    return useMemo(() => {
        if (user != null) {
            Sentry.setUser({
                email: user.email,
                id: user.id,
                segment: user.organization,
                username: `${user.firstName} ${user.lastName}`,
            });
            return user;
        }
        Sentry.setUser(null);
        return null;
    }, [user]);
}

export default useUserInfo;
